export default "__VITE_ASSET__C6mepKTY__"